
namespace 'VideoTracking', (exports) ->
  exports.track_event = (info) ->
    return false if typeof login == "undefined"
    if (typeof(os_id) == "undefined")
      ss_id = s_id
    else
      ss_id = os_id

    video_id = info.video_id
    event_type = info.event_type
    time = info.time
    duration = info.duration
    curr_time = (new Date()).getTime()
    jQuery.ajax
      type: 'POST'
      url: "#{sportbay_url}funnels/public/video/track.json"
      data:
        l: login
        s: ss_id
        video_id: video_id
        time: time
        created_at: curr_time
        event_type: event_type
        duration: duration
        url: document.location.href
jQuery ->
  if typeof(flowplayer) != 'undefined'
    fv_ga_events = [ 'start', '5%','10%','15%','20%', '25%', '50%', '75%', 'complete' ]
    flowplayer (api,root) ->
      root = jQuery(root)
      VideoTracking.track_event
        event_type: 'load'
        time: 0

      api.bind 'progress', (e,api,time) ->
        video = api.video
        dur = video.duration
        i = 0
        if dur
          if      time > (99 * dur/100)
            i = 8
          else if time > (75 * dur/100)
            i = 7
          else if time > (50 * dur/100)
            i = 6
          else if time > (25 * dur/100)
            i = 5
          else if time > (20 * dur/100)
            i = 4
          else if time > (15 * dur/100)
            i = 3
          else if time > (10 * dur/100)
            i = 2
          else if time > ( 5 * dur/100)
            i = 1

        if root.data('fv_custom_track_'+fv_ga_events[i])
          return

        for j,index in fv_ga_events
          if index == i
            break;
          if !root.data('fv_custom_track_'+fv_ga_events[index])
            return

        root.data('fv_custom_track_'+fv_ga_events[i], true);

        VideoTracking.track_event
          event_type: fv_ga_events[i]
          time: time
          video_id: video.url.replace(/.*\/attachments\//,'').replace(/\/video.*/,'')
          duration: video.duration

      api.bind 'finish ready ', (e,api) ->
        for j,index in fv_ga_events
          console.log "j: #{j}; index: #{index}"
          root.removeData('fv_custom_track_'+fv_ga_events[index])
